var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-container"},[_c('iframe',{attrs:{"src":_vm.url,"frameborder":"0","width":"100%","height":"600px","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }